import dayjs from 'dayjs';
import { stringIsNullOrEmpty } from '../../util/helpers/stringHelpers';

export function getTotalNights(startDate: string, endDate: string) {
  if (stringIsNullOrEmpty(startDate) || stringIsNullOrEmpty(endDate)) return 0;
  const startDateParsed = dayjs(startDate);
  const endDateParsed = dayjs(endDate);
  return endDateParsed.diff(startDateParsed, 'days');
}
